import { useState } from "react";

interface AdminLoginProps {
  onLogin: (email: string, password: string) => Promise<{ error?: string }>;
}

export default function AdminLogin({ onLogin }: AdminLoginProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [shake, setShake] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const result = await onLogin(email, password);

    if (result.error) {
      setError(result.error);
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setPassword("");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f7f6f4] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 className="font-['Playfair_Display'] text-3xl tracking-widest text-[#1a1a1a] uppercase mb-2">
            i-if
          </h1>
          <p className="text-xs tracking-[0.2em] text-[#888] uppercase">Admin Console</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className={`bg-white rounded-2xl p-8 ${shake ? "animate-[shake_0.4s_ease]" : ""}`}
        >
          <div className="mb-4">
            <label className="block text-xs tracking-[0.15em] text-[#888] uppercase mb-2">
              Email
            </label>
            <div className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(""); }}
                className={`w-full border rounded-lg px-4 py-3 text-sm text-[#1a1a1a] outline-none transition-colors ${
                  error ? "border-red-400 bg-red-50" : "border-[#e0e0e0] focus:border-[#1a1a1a]"
                }`}
                placeholder="admin@i-if.com"
                autoFocus
              />
              <div className="w-5 h-5 flex items-center justify-center absolute right-4 top-1/2 -translate-y-1/2 text-[#bbb]">
                <i className="ri-mail-line text-base"></i>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-xs tracking-[0.15em] text-[#888] uppercase mb-2">
              Password
            </label>
            <div className="relative">
              <input
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                className={`w-full border rounded-lg px-4 py-3 text-sm text-[#1a1a1a] outline-none transition-colors ${
                  error ? "border-red-400 bg-red-50" : "border-[#e0e0e0] focus:border-[#1a1a1a]"
                }`}
                placeholder="Enter admin password"
              />
              <div className="w-5 h-5 flex items-center justify-center absolute right-4 top-1/2 -translate-y-1/2 text-[#bbb]">
                <i className="ri-lock-line text-base"></i>
              </div>
            </div>
            {error && (
              <p className="mt-2 text-xs text-red-500">{error}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1a1a1a] text-white rounded-lg py-3 text-xs tracking-[0.15em] uppercase hover:bg-[#333] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Enter Admin"}
          </button>
        </form>

        <p className="text-center text-xs text-[#bbb] mt-6">
          i-if Admin — Authorized Access Only
        </p>
      </div>
    </div>
  );
}
